<template>
  <div class="age needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="customersAge.title" text="customersAge.info" ></Info>
    <div class="title">
      <h3>{{$t('customersAge.title')}}</h3>
    </div>
    <div class="main-content-age" :class="{'full': fullscreen}"  v-if="display">
      <chartist v-if="result && chartData.series[0].length > 0" ref="chart" :data="chartData" :options="chartOptions" type="Bar" :event-handlers="eventHandlers"></chartist>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Age',
    components: {
      Info
    },
    props: {
      result: Object, 
      display: Boolean, 
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh(old_value)
      }, 
      nbOfColumns() {
        this.refresh({})
      }
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          fullWidth: true,
          showLabel: true,
          seriesBarDistance: 10,
          stackBars: true,
          stackMode: 'accumulate',
          horizontalBars: true,
          distributeSeries: false,
          reverseData: true,
          showGrid: true,
          showGridBackground: true,
          width: '100%',
          height: '100%',
          chartPadding: 30,
          axisX: {
            offset: 0,
            onlyInteger: true
          },
          axisY: {
            offset: 20,
            onlyInteger: true
          }
        },
        myHeight: 0,
        myWidth: 0, 
        eventHandlers: []
      }
    },
    mounted() {
      if (this.$refs.chart) {
        this.$refs.chart.redraw()
      }
    },
    computed: {
      chartData() {
        let labels = []
        let series = [[]]
        if (this.result && this.result.aggregations && this.result.aggregations.ages && this.result.aggregations.ages.ages) {
          for (let i in this.result.aggregations.ages.ages.buckets) {
            labels.push(this.result.aggregations.ages.ages.buckets[i].key)
            series[0].push(this.result.aggregations.ages.ages.buckets[i].doc_count)
          }
        }
        return {labels: labels, series: series}
      }
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    },
    methods: {
      onFullScreen() {
        if(this.myHeight == 0) {
          this.myHeight = document.getElementsByClassName('main-content-age')[0].clientHeight - 4
          this.myWidth = document.getElementsByClassName('main-content-age')[0].clientWidth
        }
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          this.chartOptions.width = "70vw"
          this.chartOptions.height = "70vh"
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
        }
        this.$refs.chart.redraw()
      }, 
      refresh(old_value) {
        if(old_value && this.$refs.chart) {
          this.myWidth = document.getElementsByClassName('main-content-age')[0].clientWidth
          this.chartOptions.width = `${this.myWidth}px`
          this.$refs.chart.redraw()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/age.sass"
</style>
